import { useCallback, useState } from 'react'

// Тема кабинета. Тёмная — рабочая по умолчанию (карты/мостик), светлая — opt-in.
// Значения токенов — в index.css по атрибуту data-theme на <html>.
export type Theme = 'dark' | 'light'
const KEY = 'cabinet.theme'

export function getTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY)
    if (t === 'light' || t === 'dark') return t
  } catch {
    /* ignore */
  }
  return 'dark'
}

export function applyTheme(t: Theme): void {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('data-theme', t)
}

export function setTheme(t: Theme): void {
  try {
    localStorage.setItem(KEY, t)
  } catch {
    /* ignore */
  }
  applyTheme(t)
}

/** Применить сохранённую тему до рендера (без мигания). Зовётся в main.tsx. */
export function initTheme(): void {
  applyTheme(getTheme())
}

/** Хук: [текущая тема, переключить]. */
export function useTheme(): [Theme, () => void] {
  const [theme, setThemeState] = useState<Theme>(getTheme)
  const toggle = useCallback(() => {
    setThemeState(prev => {
      const next: Theme = prev === 'dark' ? 'light' : 'dark'
      setTheme(next)
      return next
    })
  }, [])
  return [theme, toggle]
}
